import Paper from '@mui/material/Paper';

import { styled } from 'helpers';

import { Props } from './types';

export const StyledPaper = styled(Paper)<Props>`
  &.dropdown {
    box-shadow: 0px 4px 8px rgba(34, 38, 72, 0.32);
  }
  &.smallDialog {
    box-shadow: 0px 0px 8px rgba(34, 38, 72, 0.16);
  }
  &.interaction {
    box-shadow: 0px 0px 8px rgba(34, 38, 72, 0.16);
  }
  &.modalOnOverlay {
    box-shadow: 2px 2px 16px rgba(34, 38, 72, 0.08);
  }
  &.modalOnWhite {
    box-shadow: 10px 10px 30px rgba(34, 38, 72, 0.24);
  }
  &.callPopWidget {
    box-shadow: 0px 2px 16px rgba(34, 38, 72, 0.3);
  }
`;
StyledPaper.displayName = 'Paper';
